import { render } from "./TextToText.vue?vue&type=template&id=753efccc&scoped=true"
import script from "./TextToText.vue?vue&type=script&lang=js"
export * from "./TextToText.vue?vue&type=script&lang=js"

import "./TextToText.vue?vue&type=style&index=0&id=753efccc&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./TextToText.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753efccc"]])

export default __exports__